//dependencias
import React, { Component } from 'react';

//componentes
import EntradasInventario from './entradasInv';
class Index extends Component {
    render() {
        return(
            <div className="Inicio">
                <EntradasInventario /> 
            </div>
        );
    }
}
export default Index;